/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ total: NonNullable<unknown> }} Partner_Billing_Customers_MonthInputs */



/**
* | output |
* | --- |
* | "of your {total} customers" |
*
* @param {Partner_Billing_Customers_MonthInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_billing_customers_month = /** @type {((inputs: Partner_Billing_Customers_MonthInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Billing_Customers_MonthInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`von Ihren ${i?.total} Kunden`)
	return /** @type {LocalizedString} */ (`of your ${i?.total} customers`)
});